import { Component, computed, input } from '@angular/core';
import type { RiskTone } from '../../../core/models/types';

@Component({
  selector: 'uw-progress',
  standalone: true,
  template: `
    <div
      class="h-1.5 w-full overflow-hidden rounded-full bg-surface-sunken"
      role="progressbar"
      [attr.aria-valuenow]="value()"
      [attr.aria-valuemin]="0"
      [attr.aria-valuemax]="100"
      [attr.aria-label]="label()"
    >
      <div class="h-full rounded-full transition-all duration-300" [class]="fillClass()" [style.width.%]="clamped()"></div>
    </div>
  `,
})
export class UwProgress {
  readonly value = input(0);
  readonly tone = input<RiskTone | 'ai'>('success');
  readonly label = input('progress');

  protected readonly clamped = computed(() => Math.min(100, Math.max(0, this.value())));

  protected readonly fillClass = computed(() => {
    const tones: Record<string, string> = {
      success: 'bg-success',
      warning: 'bg-warning',
      danger: 'bg-danger',
      info: 'bg-info',
      neutral: 'bg-text-muted',
      ai: 'bg-ai',
    };
    return tones[this.tone()] ?? tones['success'];
  });
}
